<template>
  <div id="app" :class="{ 'app-loaded': !isLoading }">
    <div class="preloader" v-show="isLoading">
      <div class="loader">
        <svg class="circular" viewBox="25 25 50 50">
          <circle
            class="path"
            cx="50"
            cy="50"
            r="20"
            fill="none"
            stroke-width="4"
            stroke-miterlimit="10"
          />
        </svg>
      </div>
    </div>

    <body class="landing-page" v-show="!isLoading">
      <div class="bg-ui-left"></div>
      <div class="bg-ui-right"></div>

      <NavbarSection />

      <main class="sections">
        <HeroSection />

        <VideoCards />

        <div class="text-reveal-container">
          <div class="text-reveal-wrapper">
            <p class="text-reveal" id="revealText">
              <!-- Words will be dynamically added here by JavaScript -->
            </p>
          </div>
        </div>

        <TravelCards />

        <div class="section-divider">
          <div class="divider-line"></div>
        </div>

        <TestimonialsSection />
      </main>

      <FooterSection />
    </body>
  </div>
</template>

<script>
import "./assets/css/style.css";
import "./assets/js/main.js";
import VideoCards from "./components/VideoCards.vue";
import TravelCards from "./components/TravelCards.vue";
import TestimonialsSection from "./components/Testimonials.vue";
import FooterSection from "./components/FooterSection.vue";
import NavbarSection from "./components/NavbarSection.vue";
import HeroSection from "./components/HeroSection.vue";

export default {
  name: "App",
  components: {
    VideoCards,
    TravelCards,
    TestimonialsSection,
    FooterSection,
    NavbarSection,
    HeroSection,
  },
  data() {
    return {
      isLoading: true,
    };
  },
  created() {
    // Sayfa yüklendiğinde en üste scroll yap
    window.scrollTo(0, 0);

    // Tarayıcının geri/ileri butonları için history API'sini dinle
    window.history.scrollRestoration = "manual";
  },
  mounted() {
    // Sayfa yüklenmeden önce preloader'ı göster
    this.isLoading = true;

    setTimeout(() => {
      this.isLoading = false;
    }, 800);
  },
};
</script>
